import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5030212b"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "jiaoyisheding"
};
const _hoisted_2 = {
  class: "panel"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "panel-title"
}, [/*#__PURE__*/_createElementVNode("h2", null, "交易设定")], -1));

const _hoisted_4 = {
  class: "panel-body"
};
const _hoisted_5 = {
  style: {
    "text-align": "left"
  }
};

const _hoisted_6 = /*#__PURE__*/_createTextVNode("分类：");

const _hoisted_7 = {
  style: {
    "margin": "10px 0"
  }
};

const _hoisted_8 = /*#__PURE__*/_createTextVNode("彩票：");

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "#F56C6C"
  }
}, "负", -1));

const _hoisted_10 = {
  class: "fast-set-row"
};
const _hoisted_11 = {
  class: "fast-set-item"
};

const _hoisted_12 = /*#__PURE__*/_createTextVNode("快速设置");

const _hoisted_13 = {
  class: "sub"
};

const _hoisted_14 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_15 = /*#__PURE__*/_createTextVNode("保存设置");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_link = _resolveComponent("el-link");

  const _component_el_radio_button = _resolveComponent("el-radio-button");

  const _component_el_radio_group = _resolveComponent("el-radio-group");

  const _component_el_table_column = _resolveComponent("el-table-column");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_button = _resolveComponent("el-button");

  const _component_el_table = _resolveComponent("el-table");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", null, [_createVNode(_component_el_link, {
    underline: false
  }, {
    default: _withCtx(() => [_hoisted_6]),
    _: 1
  }), _createVNode(_component_el_radio_group, {
    modelValue: $data.active_pid,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.active_pid = $event),
    size: "small",
    onChange: $options.change_group
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.game_group, item => {
      return _openBlock(), _createBlock(_component_el_radio_button, {
        key: item.name,
        label: item.pid
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
        _: 2
      }, 1032, ["label"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_link, {
    underline: false
  }, {
    default: _withCtx(() => [_hoisted_8]),
    _: 1
  }), _createVNode(_component_el_radio_group, {
    modelValue: $data.active_gid,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.active_gid = $event),
    size: "small",
    onChange: $options.change_game
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.game_list, item => {
      return _openBlock(), _createBlock(_component_el_radio_button, {
        key: item.id,
        label: item.id
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.gname), 1)]),
        _: 2
      }, 1032, ["label"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"])])]), _createVNode(_component_el_table, {
    data: $data.set_data,
    border: "",
    size: "small",
    "highlight-current-row": "",
    "header-cell-class-name": "table-header-cell",
    "header-row-class-name": "table-header-row"
  }, {
    append: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_button, {
      type: "primary",
      size: "small",
      class: "fast-btn",
      onClick: $options.fast_set_col
    }, {
      default: _withCtx(() => [_hoisted_12]),
      _: 1
    }, 8, ["onClick"])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.fast, (item, key) => {
      return _openBlock(), _createElementBlock("div", {
        class: "fast-set-item",
        key: key
      }, [_createVNode(_component_el_input, {
        modelValue: $data.fast[key],
        "onUpdate:modelValue": $event => $data.fast[key] = $event,
        size: "small",
        placeholder: "快速设置",
        class: "fast-input"
      }, null, 8, ["modelValue", "onUpdate:modelValue"])]);
    }), 128))])]),
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "name",
      label: "下注类型",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "straightbet_low",
      label: "单注最低",
      align: "center"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_input, {
        size: "small",
        modelValue: scope.row.straightbet_low,
        "onUpdate:modelValue": $event => scope.row.straightbet_low = $event,
        modelModifiers: {
          number: true
        }
      }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "straightbet_high",
      label: "单注最高",
      align: "center"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_input, {
        size: "small",
        modelValue: scope.row.straightbet_high,
        "onUpdate:modelValue": $event => scope.row.straightbet_high = $event,
        modelModifiers: {
          number: true
        }
      }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "single_high",
      label: "单期限额",
      align: "center"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_input, {
        size: "small",
        modelValue: scope.row.single_high,
        "onUpdate:modelValue": $event => scope.row.single_high = $event,
        modelModifiers: {
          number: true
        }
      }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "relax",
      label: "负值超额警示",
      align: "center"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_input, {
        style: {
          "width": "150px"
        },
        size: "small",
        modelValue: scope.row.relax,
        "onUpdate:modelValue": $event => scope.row.relax = $event,
        modelModifiers: {
          number: true
        }
      }, {
        prepend: _withCtx(() => [_hoisted_9]),
        _: 2
      }, 1032, ["modelValue", "onUpdate:modelValue"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["data"]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_button, {
    size: "small",
    type: "info",
    onClick: $options.reset
  }, {
    default: _withCtx(() => [_hoisted_14]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    size: "small",
    type: "primary",
    onClick: $options.sub_set
  }, {
    default: _withCtx(() => [_hoisted_15]),
    _: 1
  }, 8, ["onClick"])])])])]);
}